import { ZodFormattedError } from 'zod'
import { WorkModel } from '@Entities/work/work'

export const checkForErrorsInMetadata = (errors?: ZodFormattedError<WorkModel>) =>
    errors?.rightsholderProprietaryId ||
    errors?.copyrightOfficeNumber ||
    errors?.copyrightOfficeDate ||
    errors?.songCode ||
    errors?.iswc ||
    errors?.duration ||
    errors?.languageCode ||
    errors?.referenceId ||
    errors?.alternativeTitles
